import {
  checklistTemplateKeys,
  checklistTemplateEditorMutationKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { ChecklistTemplateRole } from '@core/entities/checklist/ChecklistTemplateRoles/ChecklistTemplateRole'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useUpdateChecklistTemplateRole = (
  options?: UseMutationOptions<
    ChecklistTemplateRole,
    RequestErrorType,
    RequestTypes['updateChecklistTemplateRole']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...checklistTemplateEditorMutationKeys.updateTemplateRole,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: checklistTemplateKeys.getRoles._def,
      })
    },
  })
}
